import React from 'react';
import './Error.css';

function Error() {
  return (
    <div className="error-page-container">
        <br></br>
        <h3 id="error-msg">¯\_(ツ)_/¯ <br></br> Page not found</h3>
    </div>
  );
}

export default Error;
